module.exports = __webpack_public_path__ + "static/img/all_people1.7fb2c6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/all_people1.jpg
// module id = HS3w
// module chunks = 1